import { styled } from "@mui/material/styles";

const UnorderedList = styled("ul")(({ theme }) => ({
  paddingInlineStart: theme.spacing(3),
}));

export default UnorderedList;
